import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { NavLink, Link } from "react-router-dom";
import "./Nav.css";

//redux state var
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart } from '../../feature/cartSlice';

//components 
import PopUp from '../PopUp/PopUp';
import ErrorPopUp from '../ErrorPopUp/ErrorPopUp';

function Nav(props) {

    const history = useHistory();

    const cart = useSelector(state => state.cart.value);
    const itemToShow = useSelector(state => state.cart.itemToShow);
    const error = useSelector(state => state.cart.error)
    // console.log(itemToShow, error);


    const [totalPrice, setTotalPrice] = useState(0);

    const getPrice = useCallback((bool) => {
        if (bool && cart.length > 0) {
            setTotalPrice(cart.map((item) => {
                return +item.price
            }).reduce((a,b) => a +  b))
        }
    },[cart])

    const dispatch = useDispatch();

    const [showLinks, setShowLinks] = useState(null);

    const [showCart, setShowCart] = useState(null);

    const [showNav, setShowNav] = useState(null);

    const [showShopLinks, setShowShopLinks] = useState(null);

    const transitionNavBar = () => {
        if (window.scrollY > 150) setShowNav(true);
        else {
            setShowNav(false);
            // console.log("activate nav background");
        }
    };

    useEffect(() => {
        let mounted = true;
        getPrice(mounted);

        // console.log(itemToShow);

        if (mounted && window.scrollY > 150) setShowNav(true); 
        window.addEventListener("scroll", transitionNavBar);
        
        return () => {
            mounted = false;
            window.removeEventListener("scroll", transitionNavBar);
        };
    },[showNav, getPrice]);

    return (
        <div className="Nav">

            {itemToShow ? 
                    <PopUp data={itemToShow} />
            : ''}
            {error.length > 0 ? 
                    <ErrorPopUp error={error} />
            : ''}
            <div
                className={`top__nav ${
                props.transparent && !showNav ? "transparent" : null
                }`}
            >
                <div
                className={`hamburger position__hamburger ${
                    showLinks ? "is-active" : null
                }`}
                id="hamburger-1"
                onClick={() => {
                    if (showLinks) {
                        setShowLinks(false);
                    } else {
                        setShowLinks(true);
                        setShowCart(false);
                    }
                }}
                >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
                </div>

                <svg
                width="62"
                onClick={() => history.push("/")}
                style={{ cursor: "pointer" }}
                className="logo__nav__top"
                height="14"
                >
                <path
                    d="M2.988 12.672v-7.32c0-.48.142-.928.426-1.344a3.36 3.36 0 011.11-1.02c.456-.264.94-.396 1.452-.396.296 0 .618.048.966.144.348.096.654.224.918.384L9.096.588A4.277 4.277 0 007.998.162 5.115 5.115 0 006.744 0c-.776 0-1.488.186-2.136.558-.648.372-1.188.91-1.62 1.614V.384H0v12.288h2.988zm13.472.384c1.328 0 2.526-.276 3.594-.828a6.406 6.406 0 002.532-2.304c.62-.984.93-2.116.93-3.396 0-1.288-.31-2.422-.93-3.402A6.421 6.421 0 0020.054.828C18.986.276 17.788 0 16.46 0c-1.336 0-2.536.276-3.6.828a6.476 6.476 0 00-2.532 2.298c-.624.98-.936 2.114-.936 3.402 0 1.28.312 2.412.936 3.396a6.45 6.45 0 002.538 2.304c1.068.552 2.266.828 3.594.828zm0-2.568c-.744 0-1.416-.17-2.016-.51a3.729 3.729 0 01-1.416-1.404c-.344-.596-.516-1.278-.516-2.046 0-.776.172-1.462.516-2.058a3.686 3.686 0 011.416-1.398c.6-.336 1.272-.504 2.016-.504.752 0 1.426.168 2.022.504a3.698 3.698 0 011.41 1.398c.344.596.516 1.282.516 2.058 0 .768-.172 1.45-.516 2.046a3.741 3.741 0 01-1.41 1.404c-.596.34-1.27.51-2.022.51zm15.704 2.568c1.328 0 2.526-.276 3.594-.828a6.406 6.406 0 002.532-2.304c.62-.984.93-2.116.93-3.396 0-1.288-.31-2.422-.93-3.402A6.421 6.421 0 0035.758.828C34.69.276 33.492 0 32.164 0c-1.336 0-2.536.276-3.6.828a6.476 6.476 0 00-2.532 2.298c-.624.98-.936 2.114-.936 3.402 0 1.28.312 2.412.936 3.396a6.45 6.45 0 002.538 2.304c1.068.552 2.266.828 3.594.828zm0-2.568c-.744 0-1.416-.17-2.016-.51a3.729 3.729 0 01-1.416-1.404c-.344-.596-.516-1.278-.516-2.046 0-.776.172-1.462.516-2.058a3.686 3.686 0 011.416-1.398c.6-.336 1.272-.504 2.016-.504.752 0 1.426.168 2.022.504a3.698 3.698 0 011.41 1.398c.344.596.516 1.282.516 2.058 0 .768-.172 1.45-.516 2.046a3.741 3.741 0 01-1.41 1.404c-.596.34-1.27.51-2.022.51zm12.608 2.184V4.896c0-.44.126-.85.378-1.23s.596-.686 1.032-.918c.436-.232.93-.348 1.482-.348.8 0 1.432.258 1.896.774.464.516.696 1.206.696 2.07v7.428h2.988V4.908c0-.44.124-.852.372-1.236a2.717 2.717 0 011.02-.924c.432-.232.92-.348 1.464-.348.8 0 1.438.266 1.914.798s.714 1.254.714 2.166v7.308h2.988V4.548c0-.952-.198-1.766-.594-2.442a4.051 4.051 0 00-1.62-1.56C58.818.182 58.036 0 57.156 0c-.928 0-1.744.21-2.448.63-.704.42-1.332 1.022-1.884 1.806-.312-.744-.846-1.336-1.602-1.776C50.466.22 49.604 0 48.636 0c-.752 0-1.442.152-2.07.456-.628.304-1.226.772-1.794 1.404V.384h-2.988v12.288h2.988z"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                </svg>

                {showCart ? (
                <svg
                    className="shop__cart__svg"
                    onClick={() => {
                    if (showCart) {
                        setShowCart(false);
                    } else {
                        setShowCart(true);
                        setShowLinks(false);
                    }
                    }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                    style={{ fill: "white" }}
                    d="M23 18V20H15V18H23M23 10L22.96 10.29L22 13.8C21.11 13.29 20.09 13 19 13C15.69 13 13 15.69 13 19C13 19.7 13.13 20.37 13.35 21H5.5C4.72 21 4.04 20.55 3.71 19.9L1.1 10.44L1 10C1 9.45 1.45 9 2 9H6.58L11.18 2.43C11.36 2.17 11.66 2 12 2S12.65 2.17 12.83 2.44L17.42 9H22C22.55 9 23 9.45 23 10M14 15C14 13.9 13.11 13 12 13S10 13.9 10 15 10.9 17 12 17 14 16.11 14 15M15 9L12 4.74L9 9H15Z"
                    />
                </svg>
                ) : (
                <svg
                    className="shop__cart__svg"
                    onClick={() => {
                    if (showCart) {
                        setShowCart(false);
                    } else {
                        setShowCart(true);
                        setShowLinks(false);
                    }
                    }}
                    version="1.1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                    style={{ fill: "white" }}
                    d="M5.5,21C4.72,21 4.04,20.55 3.71,19.9V19.9L1.1,10.44L1,10A1,1 0 0,1 2,9H6.58L11.18,2.43C11.36,2.17 11.66,2 12,2C12.34,2 12.65,2.17 12.83,2.44L17.42,9H22A1,1 0 0,1 23,10L22.96,10.29L20.29,19.9C19.96,20.55 19.28,21 18.5,21H5.5M12,4.74L9,9H15L12,4.74M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13Z"
                    />
                </svg>
                )}
            </div>

            <div
                className={`menu__backDrop ${
                showLinks ? "show__menu__backDrop" : undefined
                }`}
            >
                <div
                className={`bottom__nav ${showLinks ? "open__bottom__nav" : null}`}
                >
                <div className="menu__container">
                    <p className="pages nav__underline__animation">
                    <NavLink className="Nav__link__bottom pages" exact to="/">
                        Home
                    </NavLink>
                    </p>
                    <p className="pages nav__underline__animation">
                    <NavLink className="Nav__link__bottom pages" to="/contact">
                        Contact
                    </NavLink>
                    </p>
                    <p className="pages nav__underline__animation">
                    <NavLink className="Nav__link__bottom pages" to="/about">
                        About
                    </NavLink>
                    </p>
                    <p
                    className="Nav__link__bottom pages nav__underline__animation"
                    onClick={() =>
                        showShopLinks ? setShowShopLinks(false) : setShowShopLinks(true)
                    }
                    >
                    Shop
                    <svg
                        className={`arrow__svg__shop  ${
                        showShopLinks ? "open__shopDownLinks" : "close__shopDownLinks"
                        }`}
                        width="15"
                        height="12"
                        viewBox="0 0 24 24"
                    >
                        <path
                        style={{ fill: "white" }}
                        d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"
                        />
                    </svg>
                    </p>
                    <div
                    className={`shop__categories ${
                        showShopLinks ? "slide__down__div" : null
                    }`}
                    >
                    <p className="pages">
                        <NavLink
                        onClick={() => setShowLinks(false)}
                        className="Nav__link__bottom pages nav__underline__animation"
                        to="/shop/chairs"
                        >
                        Chairs
                        </NavLink>
                    </p>
                    <p className="pages">
                        <NavLink
                        onClick={() => setShowLinks(false)}
                        className="Nav__link__bottom pages nav__underline__animation"
                        to="/shop/tables"
                        >
                        Tables
                        </NavLink>
                    </p>
                    <p className="pages">
                        <NavLink
                        onClick={() => setShowLinks(false)}
                        className="Nav__link__bottom pages nav__underline__animation"
                        to="/shop/cabinets"
                        >
                        Cabinets
                        </NavLink>
                    </p>
                    <p className="pages">
                        <NavLink
                        onClick={() => setShowLinks(false)}
                        className="Nav__link__bottom pages nav__underline__animation"
                        to="/shop/room_decor"
                        >
                        Room Decor
                        </NavLink>
                    </p>
                    <p className="pages">
                        <Link
                        onClick={() => setShowLinks(false)}
                        className="Nav__link__bottom pages nav__underline__animation"
                        to="/shop"
                        >
                        All
                        </Link>
                    </p>
                    </div>
                </div>
                </div>
            </div>
            <div
                className={`grey__backDrop ${showCart ? "show__backDrop" : undefined}`}
                /*onClick={() => setShowCart(false)}*/
            >
                <div
                className={`bottom__nav__shopCart ${
                    showCart && !showLinks ? "open__nav__shopCart" : null
                }`}
                >
                    <div className="cart__container">
                    { cart.length > 0 ? 
                        <div className='cart__container__information'>
                            <p className='cart__container__title' style={{marginBottom: '10px'}}>Cart Product List</p>
                            <p>Total: ${totalPrice}</p>
                        </div>
                        : '' }
                        <div className='cart__container__content flex__shrink'>
                            {cart.length > 0 ? cart.map((item, index) => {
                                return (
                                    <div key={index} className="cart__item__container flex__shrink">
                                        <p className='flex__shrink'>{item.name}</p>

                                        <div className='img__cart__div'>
                                            <img className='img__cart' src={item.image} alt={item.name} />
                                        </div>
                                        
                                        <p className='flex__shrink' style={{borderBottom: '1px solid black'}}>${item.price}</p>
                                        <br />
                                        <p className='description__p flex__shrink'>{item.description}</p>
                                        <button onClick={() => {
                                            dispatch(removeFromCart(item.name)) 
                                        }} className='Remove__cart__btn flex__shrink'>Remove From Cart</button>
                                    </div>
                                )
                            }) : 
                                <div className='cart__no__items'>
                                    <div className='cart__empty__container'>
                                        <p className='normal__white__space'>There are no products in your cart Currently</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Nav;
